import { ref, readonly } from 'vue';

const isOpen = ref(false);

export function useVoiceCommandsModal() {
  function open() {
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
  }

  return {
    isOpen: readonly(isOpen),
    open,
    close,
  };
}
